document.addEventListener('DOMContentLoaded', () => {
  const $zipInput = document.querySelector('.js-agencyselect-zip input');
  const $select = document.querySelector('.js-agencyselect-select select');
  const list = window.agenciesByDepartment || {};
  const originalOptionsHTML = $select?.innerHTML;
  const $placeholderOption = $select?.querySelector('option[value=""]');
  let previousSet = 'original';

  function updateSelect() {
    // Extracts department from user input
    const department = $zipInput.value.substr(0, 2);

    if (department in list) {
      // Updates options if we have entries for the matching department
      if (previousSet !== department) {
        $select.innerHTML = '';

        // Creates an array of <option> elements
        const options = Object.entries(list[department]).map(([value, label]) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = label;
          return option;
        });

        $select.append($placeholderOption, ...options);

        previousSet = department;
      }
    } else if (previousSet !== 'original') {
      // Re-initialize the select to the original options.
      $select.innerHTML = originalOptionsHTML;

      previousSet = 'original';
    }
  }

  if (list && $zipInput && $select) {
    updateSelect();
    $zipInput.addEventListener('input', updateSelect);
  }
});
